/**
 * Karana Shashtyamsha D60 Color Configuration
 * Colors for 11 unique KARANA types
 */

import { KaranaType } from '../components/common/AstrologyChart/DataSections/data/KaranaShashtyamshaTableData';

/**
 * Color configuration for 11 KARANA types
 * Fixed Karanas use stronger colors, movable use softer tones
 */
export const KARANA_COLORS: Record<KaranaType, string> = {
  // Fixed #1 - Beginning
  KIMSTUGHNA: '#7c3aed',    // Violet (Ketu energy)

  // Movable cycle (7 Karanas)
  BAVA: '#f59e0b',          // Amber (Surya)
  BALAVA: '#3b82f6',        // Blue (Chandra)
  KAULAVA: '#dc2626',       // Red (Mangala)
  TAITILA: '#10b981',       // Green (Budha)
  GARIJA: '#ca8a04',        // Yellow (Guru)
  VANIJA: '#db2777',        // Pink (Shukra)
  VISHTI: '#64748b',        // Slate (Shani)

  // Fixed ending (3 Karanas)
  SHAKUNI: '#9333ea',       // Purple (Rahu illusion)
  CHATUSHPADA: '#7c3aed',   // Violet (Ketu stability)
  NAGA: '#6366f1'           // Indigo (Rahu wisdom)
};

/**
 * Get color for KARANA type
 */
export function getKaranaColor(karanaType: KaranaType): string {
  return KARANA_COLORS[karanaType] || KARANA_COLORS.BAVA;
}

/**
 * Cycle colors for visual distinction
 */
export const CYCLE_COLORS: Record<number, string> = {
  1: '#64748b',   // Slate
  2: '#0891b2',   // Cyan
  3: '#059669',   // Emerald
  4: '#7c3aed',   // Violet
  5: '#db2777',   // Pink
  6: '#ea580c',   // Orange
  7: '#ca8a04'    // Yellow
};

/**
 * Get color for cycle number
 */
export function getCycleColor(cycleNumber: number): string {
  return CYCLE_COLORS[cycleNumber] || CYCLE_COLORS[1];
}
